export const SIGN_IN = "SIGN_IN";
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const TOKEN_SUCCESS = 'TOKEN_SUCCESS'
export const SOCIAL_RECOVERY_SUCCESS = 'SOCIAL_RECOVERY_SUCCESS'
export const HASH_EMAIL = 'HASH_EMAIL'
export const INTIALIZE_LOGIN = 'INTIALIZE_LOGIN'
export const GOOGLE_LOGIN_SUCCESS = 'GOOGLE_LOGIN_SUCCESS'
export const FETCH_BALANCE = 'FETCH_BALANCE'
export const SEARCH_USER = 'SEARCH_USER'
export const REMOVE_ALERT = 'REMOVE_ALERT'
export const TRANSACTION_SUCCESS = 'TRANSACTION_SUCCESS'